import DevelopmentPage from './components/DevelopmentPage';
import PlanningSalesPage from './components/PlanningSalesPage';
import BankingPage from './components/BankingPage';
import CompanyProcedures from './components/CompanyProcedures';
import ProjectFolderGuide from './components/ProjectFolderGuide';
import InvoicesPage from './components/InvoicesPage';
import AITransformationPage from './components/AITransformationPage';
import AdvertisingPage from './components/AdvertisingPage';
import SalesIntelligencePage from './components/SalesIntelligencePage';
import RevenueDashboard from './components/RevenueDashboard';
import EmployeesPage from './components/EmployeesPage';
import LeavePage from './components/LeavePage';
import ThemePicker from './components/ThemePicker';
import PublicationsPage from './components/PublicationsPage';
import WeeklyWork from './components/WeeklyWork';
import TaxPanel from './components/TaxPanel';
import ExpensesPage from './components/ExpensesPage';
import React, { useState, useEffect, useCallback } from 'react';
import { supabase } from './supabase';
import AuthPage from './components/AuthPage';
import Dashboard from './components/Dashboard';
import CustomersPage from './components/CustomersPage';
import ProjectsPage from './components/ProjectsPage';
import PaymentsPage from './components/PaymentsPage';
import ServicesPage from './components/ServicesPage';
import SettingsPage from './components/SettingsPage';
import UsersPage from './components/UsersPage';
import TasksPage from './components/TasksPage';
import MonthlyContracts from './components/MonthlyContracts';
import ActiveWorksPage from './components/ActiveWorksPage';
import IdeasPage from './components/IdeasPage';
import DirectoryPage from './components/DirectoryPage';

// Owner / hard-admin emails. These accounts are always admin regardless of
// the profiles.role value, and other admins cannot demote them in UsersPage.
export const ADMIN_EMAILS = [
  'cagriabdullah@gmail.com',
  'cagri@liongateplanningltd.co.uk',
  'cagri@liongateconstruction.co.uk',
];

const NAV_ALL = [
  {id:'banking',label:'Finans',ownerOnly:true,bankOnly:true},
  {id:'company-procedures',label:'Şirket Prosedürleri'},
  {id:'project-folder-guide',label:'Proje Klasör Rehberi'},
  {id:'active-works',label:'Aktif İşler',icon:'✓'},
  {id:'invoices',label:'Faturalar',invoiceOnly:true},
  {id:'bot-reports',label:'Bot raporları',ownerOnly:true},
  {id:'ai-transformation',label:'AI Transformation',ownerOnly:true},
  {id:'advertising',label:'Reklamlar',ownerOnly:true},
  {id:'sales-intelligence',label:'DC Satış Fırsatları',ownerOnly:true},
  {id:'planning-development',label:'Geliştirme Fırsatları',ownerOnly:true},
  {id:'planning-sales',label:'Planning Satış Fırsatları',ownerOnly:true},
  {id:'employees',label:'Çalışanlar',ownerOnly:true},
  {id:'leave',label:'İzinlerim'},
  {id:'publications',label:'Yayınlar',pipelineOnly:true},
  {id:'team',label:'Haftalık çalışma'},
  {id:'taxes',label:'Vergiler',ownerOnly:true},
  {id:'monthly-contracts',label:'Monthly Contracts',ownerOnly:true},
  {id:'cash',label:'Giderler / Masraflarım'},
  { id: 'dashboard', label: 'Dashboard', icon: '◈', dashboardOnly: true },
  { id: 'projects', label: 'Projects', icon: '◉', notPipeline: true },
  { id: 'customers', label: 'Customers', icon: '◎', notPipeline: true },
  { id: 'payments', label: 'Payments', icon: '◆', adminOnly: true },
  { id: 'services', label: 'Services', icon: '◇', adminOnly: true },
  { id: 'tasks', label: 'Tasks', icon: '✓', adminOnly: false, pipelineOnly: false },
  { id: 'ideas', label: 'Ideas', icon: '💡', adminOnly: false, pipelineOnly: false },
  { id: 'directory', label: 'Rehber', icon: '📇' },
  { id: 'users', label: 'Users', icon: '👥', adminOnly: true },
  { id: 'settings', label: 'Settings', icon: '⚙', adminOnly: true },
];

export default function App() {
  const [page, setPage] = useState(()=>window.location.hash==='#goals'?'team':['#banking','#monthly-contracts','#active-works','#invoices','#advertising','#publications','#team','#sales-intelligence','#planning-sales','#planning-development','#ai-transformation','#bot-reports','#project-folder-guide','#company-procedures'].includes(window.location.hash)?window.location.hash.slice(1):'projects');
  useEffect(()=>{if(window.location.hash==='#goals')window.history.replaceState(null,'','#team');},[]);
  const [invoiceProject,setInvoiceProject]=useState(null);
  const [invoiceDocument,setInvoiceDocument]=useState(null);
  const consumeInvoiceDocument=useCallback(()=>setInvoiceDocument(null),[]);
  useEffect(()=>{const open=e=>{setInvoiceDocument(e.detail);setPage('invoices');};window.addEventListener('invoice:open',open);return()=>window.removeEventListener('invoice:open',open);},[]);
  const consumeInvoice=useCallback(()=>setInvoiceProject(null),[]);
  useEffect(()=>{const open=e=>{setInvoiceProject(e.detail);setPage('invoices');};window.addEventListener('invoice:project',open);return ()=>window.removeEventListener('invoice:project',open);},[]);
  const [publicationProject,setPublicationProject]=useState(null);
  const consumePublication=useCallback(()=>setPublicationProject(null),[]);
  useEffect(()=>{const open=e=>{setPublicationProject(e.detail);setPage('publications');};window.addEventListener('publication:project',open);return ()=>window.removeEventListener('publication:project',open);},[]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [projects, setProjects] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError,setLoadError]=useState('');
  const [user, setUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);
  const [profileRole, setProfileRole] = useState(null);
  const [profileLoaded, setProfileLoaded] = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
      setAuthChecked(true);
    }).catch(e=>{setLoadError(e.message);setAuthChecked(true);});
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (!user) return;
    supabase.from('profiles').select('role').eq('id', user.id).single().then(({ data }) => {
      if (data) setProfileRole(data.role);
      setProfileLoaded(true);
    }).catch(() => setProfileLoaded(true));
  }, [user]);

  const load = useCallback(async () => {
    try {
      const [p,c]=await Promise.all([supabase.from('projects').select('*, financials(*)').order('created_at',{ascending:false}),supabase.from('customers').select('*').order('created_at',{ascending:false})]);
      if(p.error||c.error)throw new Error(p.error?.message||c.error?.message);
      let invoiceLinks=[];if(user?.app_metadata?.role==='owner'||user?.app_metadata?.invoice_access){const r=await fetch('/api/invoices/project-links',{credentials:'same-origin'});if(!r.ok)throw new Error('Fatura bağlantıları yüklenemedi');invoiceLinks=(await r.json()).invoices;}
      setProjects((p.data||[]).map(p=>({...p,linkedInvoices:invoiceLinks.filter(d=>d.project_ids.includes(p.id)||p.financials?.some(f=>[f.invoice_no_1,f.invoice_no_2].includes(d.number)))})));setCustomers(c.data||[]);setLoadError('');
    }catch(e){setLoadError(e.message);}finally{setLoading(false);}
  }, [user]);

  useEffect(() => { if (user) load(); }, [user, load]);

  const signOut = async () => { await supabase.auth.signOut(); };

  const role=user?.app_metadata?.role||profileRole;
  const isOwner=role==='owner';
  const isBankOwner=isOwner&&user?.id==='6870263b-7758-4486-b372-d7fda5c998b3';
  const [workDeletionCount,setWorkDeletionCount]=useState(0);
  useEffect(()=>{if(!user?.id)return;let live=true;const refresh=async()=>{const {count,error}=await supabase.from('work_update_deletion_requests').select('id',{count:'exact',head:true}).eq('status','pending');if(live&&!error)setWorkDeletionCount(count||0);};refresh();window.addEventListener('work-deletions-changed',refresh);window.addEventListener('focus',refresh);const timer=setInterval(refresh,60000);return()=>{live=false;clearInterval(timer);window.removeEventListener('work-deletions-changed',refresh);window.removeEventListener('focus',refresh);};},[user?.id]);
  const isAdmin=['owner','operations'].includes(role);
  const isPipeline=isAdmin||role==='business_development';

  const readAllProjects=!!user?.app_metadata?.read_all_projects;
  const canInvoice=isOwner||!!user?.app_metadata?.invoice_access;
  const canRevenue=!!user?.app_metadata?.revenue_dashboard;
  const pipelineOnly = isPipeline && !isAdmin && !readAllProjects;
  const NAV = NAV_ALL.filter(n => (!n.ownerOnly || isOwner) && (!n.bankOnly || isBankOwner) && (!n.invoiceOnly || canInvoice) && (!n.dashboardOnly || isOwner || canRevenue) && (n.id!=='leave'||!isOwner) && (!['users','settings'].includes(n.id)||isOwner) && (!n.adminOnly || isAdmin) && (!n.pipelineOnly || isAdmin || isPipeline) && (!n.notPipeline || !pipelineOnly));

  // Retired/dormant modules have no live page; their records remain archived.
  useEffect(() => {
    if (['opportunities','tenders','discovery','pipeline','outreach'].includes(page)) setPage('tasks');
    if (user && !isOwner && ['taxes','employees','ai-transformation','bot-reports'].includes(page)) setPage('projects');
    if(user&&!canInvoice&&page==='invoices')setPage('projects');
    if (user && !isAdmin && ['payments', 'services', 'discovery'].includes(page)) setPage('projects');
    if (user && !isAdmin && !isPipeline && ['pipeline', 'outreach', 'publications'].includes(page)) setPage('projects');
    if (user && pipelineOnly && ['projects', 'customers'].includes(page)) setPage('tasks');
  if(user&&!isOwner&&!canRevenue&&page==='dashboard')setPage('projects');
  }, [user, isAdmin, isOwner, isPipeline, pipelineOnly, canRevenue, canInvoice, page]);

  if (!authChecked) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <div style={{ width: 36, height: 36, border: '2px solid var(--border2)', borderTopColor: 'var(--accent)', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
    </div>
  );

  if (!user) return <>{loadError&&<p role="alert">{loadError} <button onClick={()=>window.location.reload()}>Retry</button></p>}<div className="auth-theme"><ThemePicker /></div><AuthPage /></>;

  if (user && !profileLoaded) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <div style={{ width: 36, height: 36, border: '2px solid var(--border2)', borderTopColor: 'var(--accent)', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
    </div>
  );

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', flexDirection: 'column', gap: 16 }}>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <div style={{ width: 36, height: 36, border: '2px solid var(--border2)', borderTopColor: 'var(--accent)', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
      <span style={{ color: 'var(--text3)', fontSize: 13 }}>Loading...</span>
    </div>
  );

  const userName = user.user_metadata?.full_name || user.email?.split('@')[0] || 'User';

  return (
    <div className="crm-shell">
      <aside className={`crm-sidebar ${menuOpen ? 'is-open' : ''}`}>
        <div className="crm-brand"><span>L</span><div>Liongate CRM<small>Company workspace</small></div>
          <button className="crm-menu-toggle" aria-label="Toggle navigation" aria-expanded={menuOpen} onClick={() => setMenuOpen(!menuOpen)}>☰</button>
        </div>
        <nav aria-label="Main navigation">
          {[
            { label: 'Daily work', ids: ['banking','dashboard', 'projects', 'active-works', 'tasks', 'team', 'customers', 'payments', 'invoices', 'monthly-contracts', 'cash', 'taxes', 'leave'] },
            { label: 'Business development', ids: ['advertising', 'sales-intelligence', 'planning-sales', 'planning-development', 'publications', 'ideas', 'services', 'directory'] },
            { label: 'Administration', ids: ['company-procedures','project-folder-guide','ai-transformation','bot-reports', 'employees', 'users', 'settings'] },
          ].map(group => {
            const items = group.ids.map(id => NAV.find(n => n.id === id)).filter(Boolean);
            return items.length > 0 && <section key={group.label}>
              <div className="crm-nav-label">{group.label}</div>
              {items.map(n => <button key={n.id} className={`crm-nav-item ${page === n.id ? 'is-active' : ''}`} aria-current={page === n.id ? 'page' : undefined} onClick={() => {setPage(n.id); window.history.replaceState(null,'',['banking','monthly-contracts','active-works','invoices','advertising','publications','team','sales-intelligence','planning-sales','planning-development','ai-transformation','bot-reports','project-folder-guide','company-procedures'].includes(n.id)?'#'+n.id:window.location.pathname); setMenuOpen(false);}}>
                <NavIcon name={n.id} /><span>{n.label}</span>
                {n.id === 'projects' && <small>{projects.filter(p => p.status !== 'Rejected').length}</small>}
                {n.id === 'customers' && <small>{customers.length}</small>}{n.id==='team'&&workDeletionCount>0&&<small title={isOwner?'Onay bekleyen silme talepleri':'Bekleyen silme taleplerim'}>{workDeletionCount} onay</small>}
              </button>)}
            </section>;
          })}
        </nav>
        <div className="crm-account"><div className="crm-avatar">{userName.charAt(0).toUpperCase()}</div><div className="crm-account-name">{userName}<small>{isAdmin ? 'Administrator' : 'Team member'}</small></div><button onClick={signOut} title="Sign out" aria-label="Sign out">↪</button></div>
      </aside>
      <main className="crm-main">
        <header className="crm-topbar"><span>Company workspace <b>/</b> {NAV.find(n => n.id === page)?.label}</span><ThemePicker /></header>
        <div className="crm-page" key={page}>
        {loadError&&<div className="ops-error" role="alert">Could not refresh data: {loadError} <button onClick={load}>Retry</button></div>}
        {page==='publications'&&isPipeline&&<PublicationsPage user={user} projects={projects} customers={customers} initialProject={publicationProject} onConsumed={consumePublication}/>}
        {page==='project-folder-guide'&&<ProjectFolderGuide/>}
        {page==='banking'&&isBankOwner&&<BankingPage/>}
        {page==='company-procedures'&&<CompanyProcedures/>}
        {page==='ai-transformation'&&isOwner&&<AITransformationPage/>}
        {page==='bot-reports'&&isOwner&&<AITransformationPage reportsOnly/>}
        {page==='employees'&&isOwner&&<EmployeesPage user={user}/>}
        {page==='leave'&&<LeavePage user={user}/>}
        {page==='advertising' && isOwner && <AdvertisingPage />}
        {page==='team'&&<WeeklyWork user={user} manager={isAdmin} owner={isOwner} projects={projects}/>}
        {page==='taxes'&&isOwner&&<TaxPanel/>}
        {page==='monthly-contracts'&&isOwner&&<MonthlyContracts/>}
        {page==='cash'&&<ExpensesPage projects={projects}/>}
        {page==='dashboard'&&!isOwner&&canRevenue&&<RevenueDashboard/>}
        {page === 'dashboard'  && isOwner && <Dashboard projects={projects} customers={customers} user={user} />}
        {page === 'projects' && <ProjectsPage projects={projects} customers={customers} onRefresh={load} user={user} />}
        {page === 'customers' && <CustomersPage customers={customers} projects={projects} onRefresh={load} user={user} />}
        {page==='invoices'&&canInvoice&&<InvoicesPage user={user} onRefresh={load} initialProject={invoiceProject} onConsumed={consumeInvoice} initialDocument={invoiceDocument} onDocumentConsumed={consumeInvoiceDocument}/>}
        {page === 'payments' && isAdmin && <PaymentsPage projects={projects} customers={customers} onRefresh={load} user={user} />}
        {page === 'services' && isAdmin && <ServicesPage projects={projects} customers={customers} user={user} />}
        {page === 'active-works' && <ActiveWorksPage projects={projects} user={user} />}
        {page === 'tasks' && <TasksPage projects={projects} user={user} isAdmin={isAdmin} />}
        {page === 'ideas' && <IdeasPage user={user} isAdmin={isAdmin} projects={projects} profiles={[]} />}
        {page === 'sales-intelligence' && isOwner && <SalesIntelligencePage />}
        {page === 'planning-development' && isOwner && <DevelopmentPage />}
        {page === 'planning-sales' && isOwner && <PlanningSalesPage />}
          {page === 'directory' && <DirectoryPage user={user} isAdmin={isAdmin} isPipeline={isPipeline} customers={customers} />}
        {page === 'users' && isOwner && <UsersPage user={user} />}
        {page === 'settings' && isOwner && <SettingsPage />}
        </div>
      </main>
    </div>
  );
}

function NavIcon({name}) {
 const paths = {'company-procedures':'M4 3h16v18H4z M8 7h8 M8 11h8 M8 15h5','project-folder-guide':'M4 3h16v18H4z M8 7h8 M8 11h8 M8 15h5','publications':'M4 3h16v18H4z M8 7h8 M8 11h8 M8 15h5','dashboard': 'M3 3h7v7H3z M14 3h7v7h-7z M3 14h7v7H3z M14 14h7v7h-7z', 'projects': 'M3 21V5h12v16 M15 10h6v11 M7 9h4 M7 13h4 M7 17h4 M1 21h22', 'tasks': 'M9 6h12 M9 12h12 M9 18h12 M2 6l2 2 3-4 M2 12l2 2 3-4 M2 18l2 2 3-4', 'customers': 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2 M9 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8 M17 4a4 4 0 0 1 0 7 M22 21v-2a4 4 0 0 0-3-4', 'payments': 'M3 5h18v14H3z M3 10h18 M7 15h4', 'tenders': 'M8 3h8v4H8z M8 5H4v16h16V5h-4 M8 12h8 M8 16h6', 'discovery': 'M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14 M15 15l6 6', 'pipeline': 'M3 4h18l-7 8v7l-4 2v-9z', 'outreach': 'M3 10v4h4l11 5V5L7 10z M7 14l2 7 M21 9v6', 'ideas': 'M9 18h6 M9 21h6 M8 15a7 7 0 1 1 8 0l-1 3H9z', 'services': 'M4 7h16v14H4z M8 7V3h8v4 M4 12h16', 'directory': 'M4 3h16v18H4z M8 3v18 M12 8h4 M12 12h4', 'users': 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2 M9 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8 M18 9h6 M21 6v6', 'settings': 'M4 7h16 M4 17h16 M8 4v6 M16 14v6'};
 return <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d={paths[name]} /></svg>;
}
